(() => {
  let activeMedia = null;

  const clearPreview = () => {
    activeMedia?.classList.remove('is-touch-preview');
    activeMedia = null;
  };

  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'touch') return;
    const media = event.target.closest('.v2-card-media');
    if (!media?.querySelector('.v2-card-media__image--secondary')) return;
    clearPreview();
    activeMedia = media;
    activeMedia.classList.add('is-touch-preview');
  }, { passive: true });

  document.addEventListener('pointerup', clearPreview, { passive: true });
  document.addEventListener('pointercancel', clearPreview, { passive: true });
})();
